import React, {useEffect, useState} from 'react';
import {Row} from 'react-bootstrap';
import {Link, Redirect, withRouter} from 'react-router-dom'
import {useSelector} from "react-redux";
// import {connect} from 'react-redux';
import PenguinSlider from "../../components/PenguinSlider";
import ImageBox from "../../components/ImageBox";
import Designmaker_Navbar from "../../components/Designmaker_Navbar";
import {Fetch} from '../../utils';
import {use_deep_compare} from '../../hooks/deep_compare';
import DesignInfoPanel from './DesignInfoPanel';
import './style.css';
import {ClientNames, Header, ThemeConfig} from "@designs-ai/react";
import {loginHandler} from "../../utils/loginUtils";

const { feline_fetch } = Fetch;


const Recommendations_Panel = ({ recommendations, copy_into_saved_design }) => {
    try {
        const [ redirect, set_redirect ] = useState(false);
        const [ redirect_url, set_redirect_url ] = useState(null);

        const redirect_page = url => {
            set_redirect_url(url);
            set_redirect(true);
        }

        useEffect(() => {
            set_redirect(false);
            set_redirect_url(null);
        }, [redirect])

        //render
        return redirect ? (
            <Redirect push to={redirect_url} />     
        ) :  (
            recommendations && recommendations.length ? (
                <React.Fragment>
                    <Row style={{ marginTop: 5, marginBottom: 15 }}>
                            <span style={{ fontSize: 21, fontWeight: 600 }}>Explore related designs</span><br/>
                    </Row>
                    <PenguinSlider id="recommendation_slider" height={200} >
                        {recommendations.map((design, idx) => (
                            <React.Fragment>
                                <a style={{ visibility: 'hidden' }} href={global.config.website_url + 'designmaker/start/template/' + (design.custom_url||design._id)} />

                                <ImageBox
                                    key={'recommended-designs-' + idx}
                                    idx={idx}
                                    image_src={global.config.static_file_server_path + design.thumbnail + '?t='+Date.now()}
                                    name={design.name}
                                    disable_overlay={true}
                                    image_style={{
                                        maxWidth: 160,
                                        maxHeight: 185,
                                        height: 'unset',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        objectFit: 'contain',
                                        display: 'block',
                                        boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                                    }}
                                    container_style={{width: 160}}
                                    on_click={() => redirect_page('/designmaker/start/template/' + (design.custom_url||design._id))}
                                    // on_click={() => copy_into_saved_design({ id: design._id, category_id: (design.categories && design.categories.length) ? design.categories[0] : '' })}
                                    // footer_text={design.name}
                                />
                            </React.Fragment>
                        ))}                             
                    </PenguinSlider>
                </React.Fragment>
            ) : ''
        );
    } catch(err) {
        console.log('error in Recommendations --> ', err);
        return '';
    }
}


const Saved_Designs_Panel = ({ saved_designs }) => {
    try {

        //state
        const [ show_panel, set_show_panel ] = useState(false);

        //effects
        useEffect(() => {
            if (saved_designs && saved_designs.length) {
                // console.log('saved designs received')
                set_show_panel(true);
            }
        }, [ saved_designs ])

        //render
        return (
            show_panel ? (
                <React.Fragment>
                    <Row style={{marginTop: 20, marginBottom: 20}}>
                        <span style={{fontSize: 20, fontFamily: 'Montserrat', fontWeight: 800}}>Your saved designs</span>
                    </Row>
                    <PenguinSlider id="saved_design_slider" height={200} >
                        {saved_designs.map((design, idx) => (
                            <Link to={'/designmaker/start/designs/' + design._id + '/edit'}>
                                <ImageBox
                                    key={'recommended-designs-' + idx}
                                    idx={idx}
                                    image_src={global.config.static_file_server_path + design.thumbnail + '?t='+Date.now()}
                                    name={design.name}
                                    disable_overlay={true}
                                    image_style={{
                                        maxWidth: 160,
                                        maxHeight: 185,
                                        height: 'unset',
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        objectFit: 'contain',
                                        display: 'block',
                                        boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)'
                                    }}
                                    container_style={{width: 160}}
                                    // footer_text={design.name}
                                />
                            </Link>
                        ))}                             
                    </PenguinSlider>
                </React.Fragment>
            ) : ''
        );
    } catch(err) {
        console.log('error in saved design panel --> ', err);
        return '';
    }
}


const DesignPage = ({ match }) => {
    try {

        //css 
        const container_style = {
            width: '100%',
            paddingTop: 40, 
            backgroundColor: 'white',
            paddingLeft: 190,
            paddingRight: 190
        }

        const panel_style = {
            width: '100%',
            paddingTop: 0, 
            backgroundColor: 'white',
            paddingLeft: 190,
            paddingRight: 190
        }

        const container_style_tablet = {
            ...container_style,
            paddingRight: 10,
            paddingLeft: 10
        }

        //state variables
        const [ design, set_design ] = useState(null);
        const [ design_url, set_design_url ] = useState(null);
        const [ recommendations, set_recommendations ] = useState([]);
        const [ device_type, set_device_type ] = useState('desktop');
        const [ redirect, set_redirect ] = useState(false);
        const [ redirect_url, set_redirect_url ] = useState(null);

        //redux
        const user = useSelector(state => state.user);

        //memeber functions
        const fetch_recommendations = async category_id => {
            try {
                var url = 'category/get_design_recommendations';
                var body = {id: category_id};
                var recommended_designs = await feline_fetch({ url, body })
                // console.log(recommended_designs);
                set_recommendations(recommended_designs);
            } catch(err) {
                console.log(err)
            }
        }

        const fetch_design_data = async () => {
            try {
                var url = 'design/get_by_custom_url';
                var body = { custom_url: design_url };
                var data = await feline_fetch({ url, body })
                set_design(data);
            } catch(err) {
                console.log(err)
            }
        }


        const update_window_size = () => {
            if (window.innerWidth > 991) {
                set_device_type('desktop');
            } else {
                set_device_type('tablet');
            }
        }

        const fetch_design_url = () => {
            try {
                if (match.params && match.params.custom_url) {
                    set_design_url(match.params.custom_url)
                }
            } catch(err) {
                console.log("error in url --> ", err);
            }
        }

        const copy_into_saved_design = async ({ id, category_id }) => {
            try {
                var copied_design = await feline_fetch({ url: 'design/copy_into_saved_design', body: { id } });
                var category_url = '?category=' + encodeURIComponent(category_id);
                redirect_page('/designmaker/start/designs/' + copied_design._id + '/edit' + category_url);
                // console.log(copied_design);
            } catch(err) {
                console.log("error in copying into saved design ---> ", err);
            }
        }

        const redirect_page = url => {
            set_redirect_url(url);
            set_redirect(true);
        }

        const initialize = () => {
            set_design_url(null);
            set_design(null);
            fetch_design_url();
            update_window_size();
            window.onresize = update_window_size;
        }

        //effects
        useEffect(() => {
            initialize()
        }, []);

        useEffect(() => {
            // console.log('match found --< ', match)
            initialize();
        }, [ match ]);

        useEffect(() => {
            if (design_url) {
                fetch_design_data();
            }
        }, [ design_url ])

        useEffect(() => {
            if (design && design.categories && design.categories.length) {
                fetch_recommendations(design.categories[0]._id);
            }
        }, [ design ])

        useEffect(() => {
            initialize();
            set_redirect(false);
            set_redirect_url(null);
        }, [redirect])

        use_deep_compare(() => {
            if (user) {
            }
        }, [ user ])


        //result
        return redirect ? (
            <Redirect push to={redirect_url} />     
        ) : (
            <React.Fragment>
                <ThemeConfig clientName={ClientNames.designmaker}>
                    <Header
                        isLogin={user}
                        user={user}
                        clientName={ClientNames.designmaker}
                        redirectPath='/designmaker/start'
                        onAction={({action}) => loginHandler(action)}
                    />
                </ThemeConfig>
                <div style={{ paddingTop: 0 }}>
                    <div id="container" style={device_type == 'desktop' ? container_style : container_style_tablet}>
                        <DesignInfoPanel
                            design={design}
                            device_type={device_type}
                            user={user}
                            copy_into_saved_design={copy_into_saved_design}
                            redirect_page={redirect_page}
                        />
                    </div>
                    <div id="recommended_design_container" style={device_type == 'desktop' ? panel_style : container_style_tablet}>
                        <Recommendations_Panel
                            recommendations={recommendations}
                            copy_into_saved_design={copy_into_saved_design}
                            redirect_page={redirect_page}
                        />
                    </div>
                    <Row style={{marginTop: 20, marginBottom: 20}}></Row>
                </div>
            </React.Fragment>
        );
    } catch(err) {
        return '';
    }
}


const mapStateToProps = function(state) {
    return {
        user: state.user
     }
}

const mapDispatchToProps = dispatch => ({})

export default withRouter(DesignPage);